import React from 'react';
import { Box, Typography } from '@mui/material';

// Scales with the manual form or chat preview container.
const BARCODE_WIDTH = 400;
const BARCODE_HEIGHT = 100;

export default function FluidBarcode({ code }) {
  return (
    <Box
      borderRadius="4px"
      p={2}
      mb={1}
      style={{ border: '1px solid #ddd' }}
      display="flex"
      alignItems="center"
      flexDirection="column"
    >
      <img
        src={`/api/barcodes/barcode?code=${encodeURIComponent(code)}&width=${BARCODE_WIDTH}&height=${BARCODE_HEIGHT}`}
        alt="barcode"
        style={{ width: '100%', height: 'auto', display: 'block' }}
      />
      <Typography variant="h6" color="primary">
        {code}
      </Typography>
    </Box>
  );
}
